import React, { useEffect } from 'react';
import './PublishSuccessToast.css';

const PublishSuccessToast = ({ 
    isVisible, 
    onClose, 
    type = 'publish', 
    pageTitle = 'Your Page',
    liveUrl = ''
}) => {
    useEffect(() => {
        if (isVisible) {
            const timer = setTimeout(() => {
                onClose();
            }, 4000); // Auto-close after 4 seconds
            
            return () => clearTimeout(timer);
        }
    }, [isVisible, onClose]);

    if (!isVisible) return null;

    const getToastConfig = () => {
        switch (type) {
            case 'publish':
                return {
                    icon: 'fas fa-rocket',
                    title: 'Page Published!',
                    message: `"${pageTitle}" is now live and visible to visitors.`,
                    bgColor: '#10b981',
                    iconBg: '#059669'
                };
            case 'deploy':
                return {
                    icon: 'fas fa-upload',
                    title: 'Changes Deployed!',
                    message: `Latest updates to "${pageTitle}" are now live.`,
                    bgColor: '#f59e0b',
                    iconBg: '#d97706'
                };
            case 'unpublish':
                return {
                    icon: 'fas fa-eye-slash',
                    title: 'Switched to Draft',
                    message: `"${pageTitle}" is now in draft mode and offline.`,
                    bgColor: '#ef4444',
                    iconBg: '#dc2626'
                };
            default:
                return {
                    icon: 'fas fa-check',
                    title: 'Success!',
                    message: 'Action completed successfully.',
                    bgColor: '#6b7280',
                    iconBg: '#4b5563'
                };
        }
    };

    const config = getToastConfig();

    return (
        <div className="publish-toast-container">
            <div 
                className="publish-toast"
                style={{ 
                    background: `linear-gradient(135deg, ${config.bgColor} 0%, ${config.iconBg} 100%)` 
                }}
            >
                <div 
                    className="publish-toast-icon"
                    style={{ background: config.iconBg }}
                >
                    <i className={config.icon}></i>
                </div>
                
                <div className="publish-toast-content">
                    <h4 className="publish-toast-title">{config.title}</h4>
                    <p className="publish-toast-message">{config.message}</p>
                    {liveUrl && type !== 'unpublish' && (
                        <a 
                            href={liveUrl} 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className="publish-toast-link"
                        >
                            <i className="fas fa-external-link-alt"></i>
                            View Live Page
                        </a>
                    )}
                </div>
                
                <button 
                    className="publish-toast-close"
                    onClick={onClose}
                >
                    <i className="fas fa-times"></i>
                </button>
            </div>
        </div>
    );
};

export default PublishSuccessToast;
